import React from 'react';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import { useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";

const DatatableGroups = (props) => {
  // console.log(props);
  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };

  const columns = [
    {
      name: 'Aksi',
      width: '100px',
      cell: (row) => (
        <>
          <Dropdown>
            <Dropdown.Toggle variant="success" id="dropdown-content">
              Aksi
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => props.handleEdit(row)}>
                Edit
              </Dropdown.Item>
              <Dropdown.Item onClick={() => props.handleMaping(row)}>
                Maping Module
              </Dropdown.Item>
              <Dropdown.Item onClick={() => props.handleDetail(row)}>
                Detail Group
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </>
      ),
    },
    {
      name: 'Nama Group',
      selector: (row) => row.namaGroup,
    },
    {
      name: 'Fungsi Read',
      selector: (row) => (
        <>
          {row?.access_groups[0]?.lihat === 2 ? (
            <span className="badge badge-light-success">Yes</span>
          ) : (
            <span className="badge badge-light-danger">No</span>
          )}
        </>
      ),
    },
    {
      name: 'Fungsi Create',
      selector: (row) => (
        <>
          {row?.access_groups[0]?.tulis === 2 ? (
            <span className="badge badge-light-success">Yes</span>
          ) : (
            <span className="badge badge-light-danger">No</span>
          )}
        </>
      ),
    },
    {
      name: 'Fungsi Edit',
      selector: (row) => (
        <>
          {row?.access_groups[0]?.ubah === 2 ? (
            <span className="badge badge-light-success">Yes</span>
          ) : (
            <span className="badge badge-light-danger">No</span>
          )}
        </>
      ),
    },
    {
      name: 'Fungsi Delete',
      selector: (row) => (
        <>
          {row?.access_groups[0]?.hapus === 2 ? (
            <span className="badge badge-light-success">Yes</span>
          ) : (
            <span className="badge badge-light-danger">No</span>
          )}
        </>
      ),
    },
    {
      name: 'Fungsi Approval',
      selector: (row) => (
        <>
          {row?.access_groups[0]?.approval === 2 ? (
            <span className="badge badge-light-success">Yes</span>
          ) : (
            <span className="badge badge-light-danger">No</span>
          )}
        </>
      ),
    },
  ];

  return (
    <>
      <h5 className="card-title">Daftar Group</h5>
      <DataTable
        columns={columns}
        data={props.groups}
        pagination
        fixedHeader
        highlightOnHover
        subHeader
        subHeaderComponent={
          <input
            type="text"
            placeholder="Search Nama Group"
            className="w-50 form-control m-3"
            values={props.search}
            onChange={(e) => props.handleChangeSearch(e.target.value)}
          />
        }
        subHeaderAlign="center"
      />
    </>
  );
};

export default DatatableGroups;
